import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import config from 'config';
import { useSelector } from 'react-redux';
import { getClientConfig, constants } from 'redux/modules/client-config/selectors';

import '../../modules/emergencies/components/ui/emergencyPopup.css';
import {
  ShipmentsListPage,
  IncidentsListPage,
  ConfigProvider,
  SmartViewsListPage,
  SmartViewsNewPage,
  DashboardPage,
} from '@ontruck/fe-ontime';
import { LastMileShipmentDetailModule } from './last-mile-shipment-detail-module';

export function LastMileModule({ match }) {
  const TABS = useSelector((store) => getClientConfig(store, constants.TABS));

  const token = useSelector((state) => state?.user?.access_token);
  const userDelegations = useSelector((state) => state?.me?.delegations || []);
  const history = useHistory();

  let lastMileConfig = {
    apiBase: `${config.BASE_URL}`,
    token,
  };

  const handleGoToShipmentDetail = (id) => {
    history.push(`${match?.url}/shipments/${id}`);
  };

  const handleGoToSmartViews = () => {
    history.push(`${match?.url}/smart-views`);
  };

  const handleGoToSmartViewsNew = () => {
    history.push(`${match?.url}/smart-views/new`);
  };

  const handleGoToShipmentsList = () => {
    history.push(`${match?.url}/shipments`);
  };

  return (
    <ConfigProvider
      apiBase={lastMileConfig.apiBase}
      token={lastMileConfig.token}
      userDelegations={userDelegations}
    >
      <Switch>
        {TABS[constants.LAST_MILE_DASHBOARD_ENABLED] && (
          <Route exact path={`${match?.url}/dashboard`}>
            <DashboardPage />
          </Route>
        )}
        {TABS[constants.LAST_MILE_SHIPMENTS_ENABLED] && (
          <Route exact path={`${match?.url}/shipments`}>
            <ShipmentsListPage
              onGoToShipmentDetail={handleGoToShipmentDetail}
              onGoToSmartViews={handleGoToSmartViews}
            />
          </Route>
        )}
        {TABS[constants.LAST_MILE_SHIPMENTS_ENABLED] && (
          <Route exact path={`${match?.url}/smart-views`}>
            <SmartViewsListPage
              onGoToShipmentsList={handleGoToShipmentsList}
              onGoToSmartViewsNew={handleGoToSmartViewsNew}
            />
          </Route>
        )}
        {TABS[constants.LAST_MILE_SHIPMENTS_ENABLED] && (
          <Route exact path={`${match?.url}/smart-views/new`}>
            <SmartViewsNewPage onCloseDetail={handleGoToSmartViews} />
          </Route>
        )}
        {TABS[constants.LAST_MILE_ISSUES_ENABLED] && (
          <Route exact path={`${match?.url}/issues`}>
            <IncidentsListPage />
          </Route>
        )}
        <Route exact path={`${match?.url}/shipments/:id`}>
          <LastMileShipmentDetailModule />
        </Route>
      </Switch>
    </ConfigProvider>
  );
}
